<div class="replace-vehicle main">
  <div class="row">
    <div class="column twelve lg-push-two lg-eight">
      <div class="row">
        <div class="column twelve pad-bottom-20">
          <h4 class="heading-sub-section">Details of your changes</h4>
        </div>
        <div class="column twelve md-five">
          <div id="vehicleInfo" class="pad-bottom-20">
            <div>
              <h5><b>Vehicle</b></h5>
            </div>
            <div>{{ currentVehicle }}</div>
          </div>

          @if (!!(comprehensiveCoverageValue$ | async) || !!(collisionCoverageValue$ | async)) {
            <div id="deductibleInfo" class="pad-bottom-20">
              <div>
                <h5><b>Coverage Changes</b></h5>
              </div>
              @if (!!(comprehensiveCoverageValue$ | async)) {
                <div>Comprehensive Coverage ${{ comprehensiveCoverageValue$ | async }}</div>
              }
              @if (!!(collisionCoverageValue$ | async)) {
                <div>Collision Coverage ${{ collisionCoverageValue$ | async }}</div>
              }
            </div>
          }

          @if (!!(rentalReimbursementValue$ | async) || !!(ersValue$ | async)) {
            <div id="addOnCoverage" class="pad-bottom-20">
              <div>
                <h5><b>Additional Coverages</b></h5>
              </div>
              @if (rentalReimbursementValue$ | async) {
                <div class="pad-bottom-20">
                  Rental Reimbursement
                  {{ rentalReimbursementValue$ | async | formatRentalDeductibles }}
                </div>
              }
              @if (!!(ersValue$ | async)) {
                <div class="pad-bottom-20">Emergency Roadside Assistance</div>
              }
            </div>
          }
        </div>
        @if (!!(newQuote$ | async) && !!(currentQuote$ | async)) {
          <div class="column twelve md-pad-left-20 md-seven">
            <div class="row">
              @if (!changesPending && !dataLoading) {
                <div class="column twelve md-six">
                  <ds-premium-detail [quote]="currentQuote$ | async"></ds-premium-detail>
                </div>
              }
              @if (!changesPending && !dataLoading) {
                <div class="column twelve md-six">
                  <ds-premium-detail
                    hideAsterisk="true"
                    [quote]="newQuote$ | async"
                  ></ds-premium-detail>
                </div>
              }
            </div>
          </div>
        }
        <div class="column twelve pad-top-20">
          <div
            class="column tweleve md-six md-pad-right-0 pad-right-20 md-pad-bottom-0 pad-bottom-10 flex items-center"
          >
            <button ds-button class="btn -outline-white" (click)="editCoverages()">
              Edit Coverages
            </button>
          </div>

          <div class="column tweleve md-six flex items-center">
            <a class="pad-right-10" (click)="sendToAgent()">Send to agent</a>
            <button ds-button class="btn" (click)="bindQuote()">Confirm Changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
